"use client";
import { jsx } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
const VisualEditingClientComponent = lazy(() => import("../_chunks-es/VisualEditing.js"));
function VisualEditingLazyClientComponent(props) {
  return /* @__PURE__ */ jsx(Suspense, { fallback: null, children: /* @__PURE__ */ jsx(VisualEditingClientComponent, { ...props }) });
}
export {
  VisualEditingLazyClientComponent as default
};
//# sourceMappingURL=client-component.js.map
